import { useMemo } from "react";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { WhiteBoxBlock, SquareIcon } from "ui";
import { ReactComponent as UnionIcon } from "images/Union.svg";
import { BalancesItems } from "./BalancesItems";
import styles from "./balances-block.module.css";
import { CustomTabs } from "ui/CustomTabs";
import { BalanceBlockBtn } from "../BalanceBlockBtn";
import { ApproveDepositModal } from "../ApproveDepositModal";

import { PlatformDetailsModal } from "../PlatformDetailsModal/PlatformDetailsModal";
import { PayoutModal } from "../PayoutModal";
import { SAFE_DEAL } from "utils/envConstants";
import { FeeItems } from "./FeeItems";

enum TABS_KEYS_ENUM {
  FEE_STATISTICS = "feeStatistics",
  OVERALL_BALANCES = "overallBalances",
}

export const BalancesBlock = observer(() => {
  const { user, nominalAccounts } = useStores();
  const { isOperator, isProvider } = user.roles;

  const tabItems = useMemo(
    () => [
      {
        key: TABS_KEYS_ENUM.OVERALL_BALANCES,
        title: "Общий",
        children: (
          <Flex vertical gap="12px">
            <BalancesItems store={nominalAccounts.overallBalances} />
            {isOperator && !SAFE_DEAL && (
              <BalanceBlockBtn
                modal={<ApproveDepositModal />}
                modalTitle="Данные депозита"
                label="Подтвердить депозит"
              />
            )}
          </Flex>
        ),
      },
      {
        key: TABS_KEYS_ENUM.FEE_STATISTICS,
        title: "Комиссии",
        children: <FeeItems store={nominalAccounts.feeStatistics} />,
      },
    ],
    []
  );

  return (
    <WhiteBoxBlock className={styles.balancesBlock}>
      <Flex vertical gap="12px">
        <Flex align="center" gap="12px">
          <SquareIcon icon={UnionIcon} size="xl" squareSize="4xl" squareBg />

          <Typography.Title level={4} className="margin-none">
            Баланс рублей на платформе
          </Typography.Title>
        </Flex>

        {isOperator ? (
          <CustomTabs
            items={tabItems}
            defaultActiveKey={TABS_KEYS_ENUM.OVERALL_BALANCES}
            rootClassName={styles.customTabs}
          />
        ) : (
          <Flex vertical gap="12px">
            <BalancesItems store={nominalAccounts.userBalances} />
            <BalanceBlockBtn modal={<PayoutModal />} />
            {isProvider && (
              <BalanceBlockBtn
                modal={<PlatformDetailsModal />}
                label="Пополнить счет"
                modalWidth="700px"
                modalTitle="Реквизиты для пополнения"
              />
            )}
          </Flex>
        )}
      </Flex>
    </WhiteBoxBlock>
  );
});
